import {
    viewVendorTemplate,
    updateVendorTemplate,
    createVendorTemplate,
    getByIdVendor,
    updateVendor
} from "@/http/setup/vendor"

export default {
    namespaced: true,
    state: {
        vendorList: [],
        vendorTemplate: {},
        vendor: {}
    },
    actions: {
        async setVendorList({ commit }, data) {
            const resp = await viewVendorTemplate();
            commit("SET_VENDORS", resp.data);
            return resp;
        },
        async fetchTemplateAction({ commit }, data) {
            const resp = await createVendorTemplate();
            commit("VENDOR_TEMPLATE", resp.data);
            return resp;
        },
        async createVendorAction({ commit }, data) {
            const resp = await updateVendorTemplate(data);
            return resp;
        },
        async fetchVendorByIdAction({ commit }, id) {
            const resp = await getByIdVendor(id);
            commit("VENDOR_BY_ID", resp.data);
            return resp;
        },
        async updateVendorAction({ commit }, data) {
            const resp = await updateVendor(data.id, data.data);
            return resp;
        },
    },
    mutations: {
        ["SET_VENDORS"](state, payload) {
            Object.assign(state, { vendorList: payload });
        },
        ["VENDOR_TEMPLATE"](state, payload) {
            Object.assign(state, { vendorTemplate: payload });
        },
        ["VENDOR_BY_ID"](state, payload) {
            Object.assign(state, { vendor: payload });
        },
    }
}